import { graphql } from '@repo/common/queries/schemas/subgraph_prices_query'

export const query_get_oldest_price = graphql(`
  query query_get_oldest_price($vault_token_address: String!) {
    vaultPriceDatas(
      first: 1
      orderDirection: asc
      orderBy: block_number
      where: { vault_token: $vault_token_address }
    ) {
      timestamp
      price_per_token
    }
  }
`)

export const query_get_daily_price = graphql(`
  query query_get_daily_price($vault_token_address: String!) {
    vaultPriceDailyStats_collection(
      first: 365
      orderBy: timestamp
      orderDirection: desc
      where: { vault_token: $vault_token_address }
    ) {
      timestamp

      total_value
      total_tokens

      price_per_token

      undeployed_usdc_value
      undeployed_fund_value
      positions_value
    }
  }
`)
